import visa from './visa.webp';
import interac from './interac.webp';
import interacEtransfer from './interac-etransfer.webp';
import mastercard from './mastercard.webp';
import applePay from './apple-pay.webp';
import applePayV2 from './apple-pay-logo.webp';
import paymentCards from './payment-cards.webp';

export default {
  visa,
  interac,
  interacEtransfer,
  mastercard,
  applePay,
  applePayV2,
  paymentCards,
};
